import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Popconfirm, message, Row, Col, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import SideBar from '../sidebar.js';
import '../App.css';
import '../style.scss';
import "../riot_admin.scss";
import Header from '../Header.js';
import AssignDeliveryManEdit from './AssignDeliveryManEdit.js';

const AssignDeliveryManList = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [deliver, setDeliver] = useState([]);
    const [selectedDeliver, setSelectedDeliver] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    useEffect(() => {
        if (!token) {
            navigate('/AdminLogin');
            return;
        }
        fetchDelivers();
    }, []);

    const fetchDelivers = async () => {
        try {
            const response = await axios.get('https://api.starmallonline.com/api/assign-delivery/getallAssignDeliverPerson', {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
            });
            if (response.status === 401 || response.status === 404) {
                navigate('/AdminLogin');
                return;
            }
            setDeliver(response.data);
        } catch (error) {
            console.error('Error fetching employee:', error);
        }
    };
    const handleEdit = (deliver) => {
        setSelectedDeliver(deliver);
        setIsModalVisible(true);
    };
    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.delete(`https://api.starmallonline.com/api/assign-delivery/deleteAssignDeliverPerson`, {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                params: {
                    eid: id,
                },
            });

            if (response.status === 200) {
                message.success('Customer deleted successfully');
                fetchDelivers();
            } else {
                message.error('Failed to delete Customer');
            }
        } catch (error) {
            console.error('Error deleting Customer:', error);
            message.error('Failed to delete Customer');
        }
    };
    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedDeliver(null);
        fetchDelivers();
    };
    const columns = [
        {
            title: 'Employee Name',
            dataIndex: 'empName',
            key: 'empName',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Clients',
            key: 'clientid',
            render: (text, record) => (
                record.clientid.length > 0 ? record.clientid.join(', ') : 'No Clients'
            ),
        },
        {
            title: 'Delivery Products',
            key: 'deliveryProducts',
            render: (text, record) => (
                record.deliveryProducts.length > 0 ?
                    record.deliveryProducts.map(product => `${product.pname} - ${product.qnty}`).join(', ') :
                    'No Products'
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Button
                        type="primary"
                        onClick={() => handleEdit(record)}
                        style={{ marginRight: '10px' }}
                    >
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure you want to delete this assignment?"
                        onConfirm={() => handleDelete(record.assignid)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="danger">Delete</Button>
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <div className='wrapper'>
            <SideBar />
            <div className='ec-page-wrapper'>
                <Header />
                <div className="ec-content-wrapper">
                    <div className='content'>
                        <div className='breadcrumb-wrapper breadcrumb-wrapper-2 breadcrumb-contacts'>
                            <div className='col-12'>
                                <h1>ASSIGN DELIVERMAN LIST</h1>
                            </div>
                        </div>
                        <Table dataSource={deliver} columns={columns} rowKey='id' />
                    </div>
                </div>
            </div>
            {isModalVisible && (
                <Modal
                    title="Edit Assign Deliver Man"
                    open={isModalVisible}
                    onCancel={handleModalClose}
                    footer={null}
                >
                    <AssignDeliveryManEdit deliver={selectedDeliver} onClose={handleModalClose} />
                </Modal>
            )}
        </div>
    );
};

export default AssignDeliveryManList;
